import { render, staticRenderFns } from "./DatatableHeader.vue?vue&type=template&id=004c3fc0&scoped=true"
import script from "./DatatableHeader.vue?vue&type=script&lang=js"
export * from "./DatatableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c3fc0",
  null
  
)

export default component.exports